import { useSelector } from "react-redux";

const useIsLithiumEnabled = () => useSelector(state => Boolean(state.projectInfo.activeCase?.isLithiumEnabled));

export default useIsLithiumEnabled;
